// material
import { useMediaQuery } from "@material-ui/core";
// import { styled } from "@material-ui/core/styles";
import ReactApexChart from "react-apexcharts";
import "./styles-card.scss";

export default function ChartsKeterangan({ CountLine }) {
	// const theme = useTheme();
	const isSmallScreen = useMediaQuery("(max-width:780px)"); // Adjust as needed

	const chartOptions = {
		series: CountLine.datasets,

		options: {
			chart: {
				height: 350,
				type: "line",
				zoom: {
					enabled: false,
				},
				toolbar: {
					show: isSmallScreen ? false : true,
				},
			},
			dataLabels: {
				enabled: false,
			},
			stroke: {
				curve: "straight",
			},

			tooltip: {
				custom: function ({ series, seriesIndex, dataPointIndex, w }) {
					var data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
					const paragraph = [];
					CountLine.child.forEach((r) => {
						paragraph.push(
							`<p class="textP">${r.name} : ${r.data[dataPointIndex]}</p>`
						);
					});
					return `
						<div class="bubble bubble--arrow bubble--arrow-s">
							<h4>Total Ticketing</h4>
							<p class="textH">${data}</p>
							<hr />
							${paragraph.join(" ")}
						</div>
					`;
				},
			},
			markers: {
				size: 9,
				colors: "#fff",
				strokeColors: "#4eadf5",
				strokeWidth: 3,
				strokeOpacity: 0.9,
				strokeDashArray: 0,
				fillOpacity: 1,
				discrete: [],
				shape: "circle",
				radius: 2,
				offsetX: 0,
				offsetY: 0,
				showNullDataPoints: true,
				hover: {
					sizeOffset: 3,
				},
			},
			title: {
				text: `Statistik Ticketing 12 Bulan Terakhir`,
				align: "left",
				style: {
					fontSize: "16px",
					color: "#666",
				},
			},
			grid: {
				row: {
					colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
					opacity: 0.5,
				},
			},
			fill: {
				type: "gradient",
				gradient: {
					shade: "dark",
					gradientToColors: ["#ff6ec7", "#4eadf5"],
					shadeIntensity: 1,
					type: "horizontal",
					opacityFrom: 1,
					opacityTo: 1,
					stops: [0, 100, 100, 100],
				},
			},
			xaxis: {
				categories: CountLine.labels,
			},
		},
	};

	return (
		<div
			style={{
				backgroundColor: "white",
				boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
				borderRadius: "10px",
				padding: "20px",
			}}
		>
			<ReactApexChart
				type="line"
				series={chartOptions.series}
				options={chartOptions.options}
				height={564}
			/>
		</div>
	);
}
